(function () {
  if (!document.querySelector('.collection__filter-wrapper')) return;

  transformPLP();

  function transformPLP() {
    populateFilterPills();
    buildMobileOverlay();
    addInteractivity();
    setTimeout(syncFilterStateFromOriginal, 100);
    handleResponsiveFilterDisplay();
    window.addEventListener('resize', handleResponsiveFilterDisplay);
    addStickyObserver();
  }

  // Populate each pre-rendered .filter-pill with dropdown content and event listeners
  function populateFilterPills() {
    var filtersMain = document.querySelector('.collection__filters-main');
    if (!filtersMain) return;

    var filtersByLabel = buildFilterMap(filtersMain);

    document.querySelectorAll('.filter-pill').forEach(function (pill) {
      var labelEl = pill.querySelector('span');
      if (!labelEl) return;

      var label = labelEl.textContent.trim();
      var filterData = filtersByLabel[label];
      var dropdown = pill.querySelector('.filter-dropdown');

      if (filterData && dropdown) {
        populateDropdown(dropdown, filterData.values);
      }

      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleFilterDropdown(pill);
      });
    });
  }

  function buildFilterMap(filtersMain) {
    var map = {};
    filtersMain.querySelectorAll('.accordion-item').forEach(function (item) {
      var headEl = item.querySelector('.accordion-item__head');
      if (!headEl) return;
      var label = headEl.textContent.trim().replaceAll('($)', '').trim();
      var values = item.querySelectorAll('.collection__filters-value, .price-range');
      if (label) map[label] = { values: values };
    });
    return map;
  }

  function populateDropdown(dropdown, filterValues) {
    var content = document.createElement('div');
    content.style.cssText = 'display: flex; flex-direction: column; gap: 0.75rem;';
    content.addEventListener('click', function (e) { e.stopPropagation(); });

    var priceRangeContainer = null;
    filterValues.forEach(function (fv) {
      var field = fv.querySelector('.field');
      if (field) priceRangeContainer = field.closest('.price-range');
    });

    if (priceRangeContainer) {
      buildPriceRangeControl(priceRangeContainer, content, 'desktop');
    } else {
      filterValues.forEach(function (fv) {
        var input = fv.querySelector('input');
        var label = fv.querySelector('label');
        if (!input || !label || input.type === 'number') return;

        var labelText = label.textContent.replace(/\(\d+\)/, '').trim();
        var count = (label.textContent.match(/\((\d+)\)/) || ['', '0'])[1];

        var item = document.createElement('label');
        item.style.cssText =
          'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #000; padding: 0.25rem 0;';
        item.innerHTML =
          '<input type="checkbox" style="margin-right: 0.75rem;"' +
          (input.checked ? ' checked' : '') +
          ' name="' + input.name + '" value="' + input.value +
          '" data-original-id="' + input.id + '"><span>' + labelText +
          '</span><span style="margin-left: auto;">(' + count + ')</span>';

        item.querySelector('input').addEventListener('change', function (e) {
          syncCheckbox(e.target, 'desktop');
        });

        content.appendChild(item);
      });
    }

    dropdown.appendChild(content);
  }

  // Build the mobile overlay (fixed position, no CLS impact)
  function buildMobileOverlay() {
    var filtersMain = document.querySelector('.collection__filters-main');
    if (!filtersMain) return;

    var filtersByLabel = buildFilterMap(filtersMain);

    var overlay = document.createElement('div');
    overlay.className = 'mobile-filter-overlay';

    var panel = document.createElement('div');
    panel.className = 'mobile-filter-panel';

    var header = document.createElement('div');
    header.className = 'mobile-filter-header';
    header.innerHTML =
      '<h3 style="margin: 0; font-size: 18px;">FILTER & SORT</h3>' +
      '<button class="mobile-filter-close" style="background: none; border: none; font-size: 24px; cursor: pointer;">&times;</button>';

    var mobileContent = document.createElement('div');
    mobileContent.className = 'mobile-filter-content';
    mobileContent.style.cssText = 'padding: 20px;';

    var sortRadioInputs = document.querySelectorAll(
      '.mak-desktop-filters .collection__sort input[type="radio"][name="Sort"]'
    );
    if (sortRadioInputs.length > 0) {
      mobileContent.appendChild(buildMobileSortSection(sortRadioInputs));
    }

    document.querySelectorAll('.filter-pill').forEach(function (pill) {
      var labelEl = pill.querySelector('span');
      if (!labelEl) return;
      var label = labelEl.textContent.trim();
      var filterData = filtersByLabel[label];
      if (filterData) {
        mobileContent.appendChild(buildMobileFilterSection(label, filterData.values));
      }
    });

    var footer = document.createElement('div');
    footer.className = 'mobile-filter-footer';
    footer.innerHTML =
      '<button class="mobile-apply-filters" style="width: 100%; padding: 15px; background: #000; color: white; border: none; font-size: 16px; cursor: pointer;">APPLY</button>';

    footer.querySelector('.mobile-apply-filters').addEventListener('click', function () {
      hideMobileFilters();
      setTimeout(updateResultCount, 1000);
    });
    header.querySelector('.mobile-filter-close').addEventListener('click', hideMobileFilters);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hideMobileFilters();
    });

    document.querySelector('.mobile-filter-button').addEventListener('click', showMobileFilters);

    panel.appendChild(header);
    panel.appendChild(mobileContent);
    panel.appendChild(footer);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
  }

  function buildMobileSortSection(sortRadioInputs) {
    var section = document.createElement('div');
    section.className = 'mobile-filter-section mobile-sort-section';
    section.style.cssText = 'border-bottom: 1px solid #e5e5e5; margin-bottom: 20px;';

    var hdr = document.createElement('div');
    hdr.className = 'mobile-filter-section-header';
    hdr.innerHTML =
      '<span style="font-weight: 500; font-size: 16px;">SORT BY</span>' +
      '<svg width="15" height="15" viewBox="0 -0.112 9.825 9.825" xmlns="http://www.w3.org/2000/svg"><path d="m1.2 3.581 0.637 -0.637 3.075 3.056 3.075 -3.056 0.637 0.637 -3.712 3.675z"></path></svg>';

    var content = document.createElement('div');
    content.style.cssText = 'max-height: 0; overflow: hidden; transition: max-height 0.3s ease;';

    var inner = document.createElement('div');
    inner.style.cssText = 'padding-bottom: 15px;';

    var currentSelected = Array.from(sortRadioInputs).find(function (i) {
      return i.getAttribute('checked') === 'checked';
    });

    sortRadioInputs.forEach(function (originalInput) {
      var originalLabel = document.querySelector('label[for="#' + originalInput.id + '"]');
      if (!originalLabel) return;

      var item = document.createElement('label');
      item.style.cssText =
        'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #000; padding: 8px 0;';
      item.innerHTML =
        '<input type="radio" name="mobile-sort" value="' + originalInput.value +
        '" style="margin-right: 12px;"' +
        (currentSelected && currentSelected.value === originalInput.value ? ' checked' : '') +
        '><span>' + originalLabel.textContent.trim() + '</span>';

      item.querySelector('input').addEventListener('change', function (e) {
        if (e.target.checked) {
          originalInput.click();
          document.querySelectorAll('input[name="mobile-sort"]').forEach(function (i) {
            i.checked = i.value === originalInput.value;
          });
        }
      });

      inner.appendChild(item);
    });

    content.appendChild(inner);
    section.appendChild(hdr);
    section.appendChild(content);
    hdr.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleAccordion(content, hdr.querySelector('svg'));
    });
    return section;
  }

  function buildMobileFilterSection(filterTitle, filterValues) {
    var section = document.createElement('div');
    section.className = 'mobile-filter-section';
    section.style.cssText = 'border-bottom: 1px solid #e5e5e5; margin-bottom: 20px;';

    var hdr = document.createElement('div');
    hdr.className = 'mobile-filter-section-header';
    hdr.innerHTML =
      '<span style="font-weight: 500; font-size: 16px;">' + filterTitle.toUpperCase() + '</span>' +
      '<svg width="15" height="15" viewBox="0 -0.112 9.825 9.825" xmlns="http://www.w3.org/2000/svg"><path d="m1.2 3.581 0.637 -0.637 3.075 3.056 3.075 -3.056 0.637 0.637 -3.712 3.675z"></path></svg>';

    var content = document.createElement('div');
    content.style.cssText = 'max-height: 0; overflow: hidden; transition: max-height 0.3s ease;';

    var inner = document.createElement('div');
    inner.style.cssText = 'padding-bottom: 15px;';

    var priceRangeContainer = null;
    filterValues.forEach(function (fv) {
      var field = fv.querySelector('.field');
      if (field) priceRangeContainer = field.closest('.price-range');
    });

    if (priceRangeContainer) {
      buildPriceRangeControl(priceRangeContainer, inner, 'mobile');
    } else {
      filterValues.forEach(function (fv) {
        var input = fv.querySelector('input');
        var label = fv.querySelector('label');
        if (!input || !label || input.type === 'number') return;

        var labelText = label.textContent.replace(/\(\d+\)/, '').trim();
        var count = (label.textContent.match(/\((\d+)\)/) || ['', '0'])[1];

        var item = document.createElement('label');
        item.style.cssText =
          'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #000; padding: 8px 0;';
        item.innerHTML =
          '<input type="checkbox" style="margin-right: 12px;"' +
          (input.checked ? ' checked' : '') +
          ' name="' + input.name + '" value="' + input.value +
          '" data-original-id="' + input.id + '"><span>' + labelText +
          '</span><span style="margin-left: auto; color: #666;">(' + count + ')</span>';

        item.querySelector('input').addEventListener('change', function (e) {
          syncCheckbox(e.target, 'mobile');
        });

        inner.appendChild(item);
      });
    }

    content.appendChild(inner);
    section.appendChild(hdr);
    section.appendChild(content);
    hdr.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleAccordion(content, hdr.querySelector('svg'));
    });
    return section;
  }

  function buildPriceRangeControl(priceRangeContainer, container, context) {
    var fromInput = priceRangeContainer.querySelector('input[name*="price.gte"], input[data-price-min]');
    var toInput = priceRangeContainer.querySelector('input[name*="price.lte"], input[data-price-max]');
    if (!fromInput && !toInput) return;

    var wrap = document.createElement('div');
    wrap.style.cssText = 'display: flex; flex-direction: column; gap: 1rem; padding: 0.5rem 0;';

    var html = '<div style="font-weight: 600; font-size: 16px; margin-bottom: 0.5rem; color: #000;">Price Range</div>' +
      '<div style="display: flex; gap: 1rem; align-items: center;">';

    if (fromInput) {
      html += '<div style="flex: 1;"><label style="display: block; font-size: 14px; color: #666; margin-bottom: 0.25rem;">From</label>' +
        '<input type="number" style="width: 100%; padding: 0.5rem; border: 1px solid #ccc; border-radius: 4px; font-size: 16px; color: #000;"' +
        ' placeholder="' + (fromInput.placeholder || '0.00') + '" min="' + (fromInput.min || '0') +
        '" max="' + (fromInput.max || '1000') + '" data-original-id="' + fromInput.id +
        '" value="' + (fromInput.value || '') + '"></div>';
    }
    if (toInput) {
      html += '<div style="flex: 1;"><label style="display: block; font-size: 14px; color: #666; margin-bottom: 0.25rem;">To</label>' +
        '<input type="number" style="width: 100%; padding: 0.5rem; border: 1px solid #ccc; border-radius: 4px; font-size: 16px; color: #000;"' +
        ' placeholder="' + (toInput.placeholder || '800.00') + '" min="' + (toInput.min || '0') +
        '" max="' + (toInput.max || '1000') + '" data-original-id="' + toInput.id +
        '" value="' + (toInput.value || '') + '"></div>';
    }
    html += '</div>';
    wrap.innerHTML = html;
    wrap.addEventListener('click', function (e) { e.stopPropagation(); });

    if (fromInput) {
      var newFrom = wrap.querySelector('input[data-original-id="' + fromInput.id + '"]');
      if (newFrom) bindPriceInput(newFrom, fromInput, context);
    }
    if (toInput) {
      var newTo = wrap.querySelector('input[data-original-id="' + toInput.id + '"]');
      if (newTo) bindPriceInput(newTo, toInput, context);
    }

    container.appendChild(wrap);
  }

  function syncCheckbox(newInput, fromContext) {
    var originalId = newInput.getAttribute('data-original-id');
    var originalInput = document.querySelector('#' + originalId);
    if (!originalInput) return;

    originalInput.click();

    var counterpartSelector = fromContext === 'desktop'
      ? '.mobile-filter-content input[data-original-id="' + originalId + '"]'
      : '.filter-dropdown input[data-original-id="' + originalId + '"]';
    var counterpart = document.querySelector(counterpartSelector);
    if (counterpart) counterpart.checked = newInput.checked;

    setTimeout(updateResultCount, 1500);
  }

  function bindPriceInput(newInput, originalInput, context) {
    var update = function () {
      originalInput.value = newInput.value;
      originalInput.dispatchEvent(new Event('input', { bubbles: true }));
      originalInput.dispatchEvent(new Event('change', { bubbles: true }));

      var counterpartSelector = context === 'mobile'
        ? '.filter-dropdown input[data-original-id="' + originalInput.id + '"]'
        : '.mobile-filter-content input[data-original-id="' + originalInput.id + '"]';
      var counterpart = document.querySelector(counterpartSelector);
      if (counterpart) counterpart.value = newInput.value;

      setTimeout(updateAppliedFilters, 100);
      setTimeout(updateResultCount, 1000);
    };

    newInput.addEventListener('input', nantuDebounce(update, 500));
    newInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); update(); }
    });
    newInput.addEventListener('blur', function () {
      if (newInput.value !== originalInput.value) update();
    });
  }

  function toggleAccordion(content, arrow) {
    var isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';
    content.style.maxHeight = isOpen ? '0' : content.scrollHeight + 'px';
    if (arrow) arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
  }

  function showMobileFilters() {
    var overlay = document.querySelector('.mobile-filter-overlay');
    var panel = document.querySelector('.mobile-filter-panel');
    if (overlay && panel) {
      overlay.style.display = 'block';
      setTimeout(function () { panel.style.transform = 'translateX(0)'; }, 10);
      document.body.style.overflow = 'hidden';
    }
  }

  function hideMobileFilters() {
    var overlay = document.querySelector('.mobile-filter-overlay');
    var panel = document.querySelector('.mobile-filter-panel');
    if (overlay && panel) {
      panel.style.transform = 'translateX(100%)';
      setTimeout(function () {
        overlay.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
  }

  function handleResponsiveFilterDisplay() {
    var isMobile = window.innerWidth <= 992;
    var filterPills = document.querySelector('.collection__filter-pills');
    var mobileHeader = document.querySelector('.mobile-header');
    var mobileResultCount = document.querySelector('.mobile-result-count');
    var resultCount = document.querySelector('.collection__results');

    if (!filterPills || !mobileHeader) return;

    if (isMobile) {
      filterPills.style.display = 'none';
      mobileHeader.style.display = 'flex';
      if (resultCount && mobileResultCount) {
        mobileResultCount.textContent = resultCount.textContent.trim();
      }
      hideMobileFilters();
    } else {
      filterPills.style.display = 'flex';
      mobileHeader.style.display = 'none';
      hideMobileFilters();
    }
  }

  function addInteractivity() {
    document.addEventListener('exo:update-collection-items', function (event) {
      if (event.detail && event.detail.html) updatePageContentFromEvent(event.detail.html);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.filter-pill')) closeAllDropdowns();
    });
  }

  function updateResultCount() {
    var resultCount = document.querySelector('.collection__results');
    var mobileResultCount = document.querySelector('.mobile-result-count');
    if (resultCount && mobileResultCount) {
      mobileResultCount.textContent = (resultCount.textContent || resultCount.innerText)
        .replace('Showing all', '').replace('results', 'products').replace('result', 'product').trim();
    }
  }

  function updatePageContentFromEvent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('.collection__items-grid');
    var currentGrid = document.querySelector('.collection__items-grid');
    if (newGrid && currentGrid) {
      var scrollY = window.pageYOffset;
      currentGrid.innerHTML = newGrid.innerHTML;
      window.scrollTo(0, scrollY);
    }
    setTimeout(syncFilterStateFromOriginal, 100);
  }

  function syncFilterStateFromOriginal() {
    document.querySelectorAll('.collection__filters-main input[type="checkbox"]').forEach(function (orig) {
      var desktop = document.querySelector('.filter-dropdown input[data-original-id="' + orig.id + '"]');
      var mobile = document.querySelector('.mobile-filter-content input[data-original-id="' + orig.id + '"]');
      if (desktop) desktop.checked = orig.checked;
      if (mobile) mobile.checked = orig.checked;
    });
    document.querySelectorAll('.collection__filters-main input[type="number"]').forEach(function (orig) {
      var desktop = document.querySelector('.filter-dropdown input[data-original-id="' + orig.id + '"]');
      var mobile = document.querySelector('.mobile-filter-content input[data-original-id="' + orig.id + '"]');
      if (desktop) desktop.value = orig.value;
      if (mobile) mobile.value = orig.value;
    });
    updateAppliedFilters();
  }

  function updateAppliedFilters() {
    var container = document.querySelector('.applied-filters');
    if (!container) return;
    container.innerHTML = '';

    var seenIds = new Set();
    var checkedInputs = [];

    document.querySelectorAll('.filter-dropdown input[type="checkbox"]:checked, .mobile-filter-content input[type="checkbox"]:checked').forEach(function (input) {
      var originalId = input.getAttribute('data-original-id');
      if (originalId && !seenIds.has(originalId)) {
        var orig = document.querySelector('#' + originalId);
        if (orig && orig.checked) { checkedInputs.push(input); seenIds.add(originalId); }
      }
    });

    var priceInputs = [];
    document.querySelectorAll('.filter-dropdown input[type="number"], .mobile-filter-content input[type="number"]').forEach(function (input) {
      if (input.value && input.value.trim()) {
        var id = input.getAttribute('data-original-id');
        if (!priceInputs.find(function (i) { return i.getAttribute('data-original-id') === id; })) {
          priceInputs.push(input);
        }
      }
    });

    checkedInputs.forEach(function (input) { createAppliedFilterTag(input, container); });

    var fromInput = priceInputs.find(function (i) { return /gte|GTE/.test(i.getAttribute('data-original-id') || ''); });
    var toInput = priceInputs.find(function (i) { return /lte|LTE/.test(i.getAttribute('data-original-id') || ''); });
    if (fromInput || toInput) createPriceFilterTag(fromInput, toInput, container);

    if (checkedInputs.length > 0 || priceInputs.length > 0) {
      var clearBtn = document.createElement('button');
      clearBtn.textContent = 'Clear All';
      clearBtn.style.cssText = 'background: none; border: none; color: #000; text-decoration: underline; cursor: pointer; font-size: 16px; margin-left: 10px;';
      clearBtn.addEventListener('click', clearAllFilters);
      container.appendChild(clearBtn);
    }
  }

  function createAppliedFilterTag(input, container) {
    var pill = input.closest('.filter-pill');
    var filterName = pill && pill.querySelector('span') ? pill.querySelector('span').textContent : '';
    if (!filterName) {
      var mobileSection = input.closest('.mobile-filter-section');
      var sectionHdr = mobileSection && mobileSection.querySelector('.mobile-filter-section-header span');
      if (sectionHdr) filterName = sectionHdr.textContent;
    }

    var originalId = input.getAttribute('data-original-id');
    if (!filterName || !input.value || !originalId) return;

    var tag = document.createElement('div');
    tag.className = 'applied-filter-tag';
    tag.setAttribute('data-original-id', originalId);
    tag.innerHTML =
      '<span>' + filterName + ': ' + input.value + '</span>' +
      '<button style="margin-left: 0.75rem; background: none; border: none; color: white; cursor: pointer; padding: 0; display: flex; align-items: center;">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path d="M11 3L3 11M3 3l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';

    tag.querySelector('button').addEventListener('click', function () {
      var orig = document.querySelector('#' + originalId);
      if (orig) {
        orig.click();
        var desktop = document.querySelector('.filter-dropdown input[data-original-id="' + originalId + '"]');
        var mobile = document.querySelector('.mobile-filter-content input[data-original-id="' + originalId + '"]');
        if (desktop) desktop.checked = false;
        if (mobile) mobile.checked = false;
        setTimeout(function () { syncFilterStateFromOriginal(); updateResultCount(); }, 1500);
      }
    });

    container.appendChild(tag);
  }

  function createPriceFilterTag(fromInput, toInput, container) {
    var text = 'Price: ';
    var from = fromInput ? '$' + fromInput.value : '';
    var to = toInput ? '$' + toInput.value : '';
    if (from && to) text += from + ' - ' + to;
    else if (from) text += 'From ' + from;
    else text += 'Up to ' + to;

    var tag = document.createElement('div');
    tag.className = 'applied-filter-tag price-filter-tag';
    tag.innerHTML =
      '<span>' + text + '</span>' +
      '<button style="margin-left: 0.75rem; background: none; border: none; color: white; cursor: pointer; padding: 0; display: flex; align-items: center;">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path d="M11 3L3 11M3 3l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';

    tag.querySelector('button').addEventListener('click', function () {
      var clearOriginal = function (proxyInput) {
        if (!proxyInput) return;
        var id = proxyInput.getAttribute('data-original-id');
        var orig = document.querySelector('#' + id);
        if (orig) {
          orig.value = '';
          orig.dispatchEvent(new Event('input', { bubbles: true }));
          orig.dispatchEvent(new Event('change', { bubbles: true }));
        }
        proxyInput.value = '';
        var counterpart = document.querySelector('.mobile-filter-content input[data-original-id="' + id + '"]') ||
          document.querySelector('.filter-dropdown input[data-original-id="' + id + '"]');
        if (counterpart) counterpart.value = '';
      };
      clearOriginal(fromInput);
      setTimeout(function () { clearOriginal(toInput); }, 100);
      setTimeout(function () { syncFilterStateFromOriginal(); updateAppliedFilters(); }, 500);
      setTimeout(updateResultCount, 1500);
    });

    container.appendChild(tag);
  }

  function clearAllFilters() {
    var clearBtn = document.querySelector('.mak_clear-filterss');
    if (!clearBtn) return;
    document.querySelector('.applied-filters').innerHTML = '';
    clearBtn.click();
    document.querySelectorAll('.filter-dropdown input[type="checkbox"]:checked, .mobile-filter-content input[type="checkbox"]:checked').forEach(function (i) { i.checked = false; });
    document.querySelectorAll('.filter-dropdown input[type="number"], .mobile-filter-content input[type="number"]').forEach(function (i) { i.value = ''; });
    setTimeout(syncFilterStateFromOriginal, 500);
    setTimeout(updateResultCount, 1500);
  }

  function toggleFilterDropdown(pill) {
    var dropdown = pill.querySelector('.filter-dropdown');
    var isOpen = dropdown.style.display === 'block';
    closeAllDropdowns();
    if (!isOpen) {
      dropdown.style.display = 'block';
      pill.classList.add('active');
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.filter-dropdown').forEach(function (d) { d.style.display = 'none'; });
    document.querySelectorAll('.filter-pill').forEach(function (p) { p.classList.remove('active'); });
  }

  function addStickyObserver() {
    var filterWrapper = document.querySelector('.collection__filter-wrapper');
    var collectionHead = document.querySelector('.collection__head');
    var header = document.querySelector('.header');
    if (!filterWrapper || !collectionHead) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var isIntersecting = entries[0].isIntersecting;
        filterWrapper.classList.toggle('sticky', !isIntersecting);
        if (header) header.classList.toggle('dnone', !isIntersecting);
      },
      { threshold: window.innerWidth > 500 ? 0.9 : 0.5, rootMargin: '-1px 0px 0px 0px' }
    );

    observer.observe(collectionHead);
  }

  function nantuDebounce(func, wait) {
    var timeout;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () { func.apply(ctx, args); }, wait);
    };
  }
})();
